// src/slices/paymentSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transactionID: null,
  mrNo:         null,
  doctorId:     null,
  paymentPortal:null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPaymentData: (state, action) => {
      state.transactionID  = action.payload.transactionID;
      state.mrNo           = action.payload.mrNo;
      state.doctorId       = action.payload.doctorId;
      state.paymentPortal  = action.payload.paymentPortal;
    },
    clearPaymentData: (state) => {
      state.transactionID = null;
      state.mrNo          = null;
      state.doctorId      = null;
      state.paymentPortal = null;
    },
  },
});

export const { setPaymentData, clearPaymentData } = paymentSlice.actions;
export default paymentSlice.reducer;
